import type { HandoffRouteResolver } from './handoffNavigation'

function texto (valor: unknown): string | null {
  return typeof valor === 'string' ? valor : null
}

export interface JanelaDaTela {
  location?: { hash?: unknown }
}

export function lerRotaDaJanela (janela: JanelaDaTela | null | undefined): string | null {
  let hash: unknown
  try {
    hash = janela?.location?.hash
  } catch {
    return null
  }

  if (hash === undefined || hash === null) return null
  const fragmento = texto(hash)
  if (fragmento === null) return null
  if (fragmento.length === 0) return '/'

  const semCerquilha = fragmento.startsWith('#') ? fragmento.slice(1) : fragmento
  const caminho = semCerquilha.split('?')[0]
  return caminho.length === 0 ? '/' : caminho
}

/** O boot injeta o router sem criar um ciclo com a store. */
let resolvedorDeRotaLocal: HandoffRouteResolver | null = null

export function registrarResolvedorDeRotaLocal (resolver: HandoffRouteResolver | null): void {
  resolvedorDeRotaLocal = resolver
}

export function obterResolvedorDeRotaLocal (): HandoffRouteResolver | null {
  return resolvedorDeRotaLocal
}
